import { generateKey } from 'constants/helper';

import ColorCodedDate from './common/ColorCodedDate';
import { BasicEmployee } from './employee';
import Team from './team';

export class OwnerCollaboratorEmployee extends BasicEmployee {
  constructor({ ownerType, id, displayName, profilePhoto, designation }) {
    super({
      id,
      displayName,
      designation,
      profilePhotoSrc: profilePhoto,
    });
    this.ownerType = ownerType;
  }

  static fromJSON({ ownerType, id, displayName, profilePhoto, designation }) {
    return new OwnerCollaboratorEmployee({
      ownerType,
      id,
      displayName,
      profilePhoto,
      designation,
    });
  }
}

class ActionItemLabel {
  constructor({ uuid, labelType }) {
    this.uuid = uuid;
    this.labelType = labelType;
  }

  static fromJSON({ uuid, labelType }) {
    return new ActionItemLabel({
      uuid,
      labelType,
    });
  }
}

export class ActionItem {
  constructor({ uuid, text, status, uiKey, toIds, dueTime, label, teams }) {
    this.uuid = uuid;
    this.text = text;
    this.status = status;
    this.toIds = toIds;
    this.uiKey = uiKey;
    this.dueTime = dueTime;
    this.label = label;
    this.teams = teams;
  }

  static fromJSON({ uuid, text, status, uiKey, toIds, dueTime, label = null, teams }) {
    return new ActionItem({
      uuid,
      text,
      status,
      uiKey: uiKey ?? generateKey(7),
      toIds: Array.isArray(toIds) ? toIds.map((emp) => OwnerCollaboratorEmployee.fromJSON(emp)) : [],
      label: label ? ActionItemLabel.fromJSON(label) : null,
      teams: Array.isArray(teams) ? teams.map((team) => Team.fromJSON1(team)) : [],
      dueTime: dueTime ? ColorCodedDate.fromJSON(dueTime) : {},
    });
  }
}
